import 'date-fns';
import React, { useMemo } from "react";
import { isAfter, } from 'date-fns';
import * as wjInput from '@grapecity/wijmo.react.input';
import {
  Grid, Paper, FormControl,
  TextField, makeStyles, Theme,
  createStyles, InputLabel, Select,
  MenuItem, Button, OutlinedInput,
  Chip, Checkbox, ListItemText,
  CircularProgress,
  Accordion, AccordionDetails,
  AccordionSummary, Typography, FormHelperText, FormControlLabel
} from '@material-ui/core'
import { green } from '@material-ui/core/colors';
import { Autocomplete } from '@material-ui/lab';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import TextMaskInput from '../../TextMaskInput'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { typeCisUserList, typeContractList } from '../../../../api/helpline/keiyaku'
import { typeCategory } from '../../../../api/helpline/master'
import { typeCustomerList } from '../../../../api/helpline/qa';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      width: '80%'
    },
    form: {
      margin: theme.spacing(2),
      padding: theme.spacing(1),
    },
    mWidth: {
      marginTop: theme.spacing(1),
      maxWidth: "80%",
      minWidth: "40%"
    },
    departmentWidth: {
      marginTop: theme.spacing(1),
      width: "90%",
    },
    chip: {
      margin: "2px 2px 2px"
    },
    status: {
      marginTop: 4,
      marginRight: 2,
      marginbottom: 4,
      marginLeft: 10,
      color: "rgba(0, 0, 0, 0.54)"
    },
    shrink: {
      transform: "translate(14px, -6px) scale(0.75)"
    },
    button: {
      margin: theme.spacing(1),
    },
    card: {
      borderColor: "rgba(0, 0, 0, 0.2)",
      margin: theme.spacing(1),
      maxWidth: '60%'
    },
    chips: {
      display: "flex",
      flexWrap: "wrap"
    },
    wrapper: {
      position: 'relative',
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '33.33%',
      flexShrink: 0,
    },
    lWidth: {
      marginTop: theme.spacing(1),
      width: "100%",
    },
  }),
);

interface Form {
  userId: string,
  qano: string,
  qastatus: string[],
  keyword: string,
  keiyakuno: string,
  keiyakuClsCd: string,
  qaSeCd: string,
}

interface Props {
  form: Form,
  PickerToolBar: (props: any) => JSX.Element,
  chipDelete: (i: number) => void,
  handleChangeForm: (event: React.ChangeEvent<{
    value: unknown;
    name?: string | undefined;
  }>) => void,
  onSubmit: () => void,
  qastatusName: string[],
  contractList: typeContractList[] | undefined,
  qastatus: typeCategory[],
  loading: boolean,
  startdate: Date | null,
  enddate: Date | null,
  _onValueChanged: (sender: {
    value: Date;
    inputElement: HTMLInputElement;
  }) => void
  _onInitialized: (sender: any) => void,
  customerList: typeCustomerList[] | undefined,
  handleChangeCompanyCd: (companyObj: typeCustomerList | null) => void,
  handleChangeKeiyakuCd: (keiyakuObj: typeContractList | null) => void,
  cisUserList: typeCisUserList[] | undefined,
  loginUser: boolean,
  handleSetLoginUserCd: (event: React.ChangeEvent<HTMLInputElement>) => void,
  handleChangeSeCd: (seObj: typeCisUserList | null) => void
}
const ITEM_HEIGHT = 90;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      minWidth: 200,
      maxWidth: 200
    }
  }
};

const QAListForm: React.FC<Props> = (props) => {
  const classes = useStyles();
  const { loading, contractList, qastatus, form, qastatusName, chipDelete, handleChangeForm, onSubmit, _onInitialized, _onValueChanged, startdate, enddate, customerList, handleChangeCompanyCd, handleChangeKeiyakuCd, cisUserList, handleChangeSeCd, handleSetLoginUserCd, loginUser } = props
  const [expanded, setExpanded] = React.useState<string | false>('panel');

  const handleChange = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const datecheck = useMemo((): boolean => {
    if (startdate && enddate) {
      const result = isAfter(startdate, enddate)
      return result
    } else {
      return false
    }
  }, [startdate, enddate])

  const check = datecheck ? true : loading ? true : false

  return (
    <React.Fragment>
      <Accordion expanded={expanded === 'panel'} onChange={handleChange('panel')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="filtering"
          id="filtering-header"
        >
          <Typography className={classes.heading}>Q&A 検索条件</Typography>
        </AccordionSummary>
        <AccordionDetails style={{ padding: '0' }}>
          <Grid container direction="row" justify="center" alignItems="center">
            <Paper elevation={0} className={classes.paper}>
              <Grid container direction="row" justify="flex-start" alignItems="center">
                <Grid item xs={12} sm={5}>
                  <FormControl className={classes.mWidth} variant="outlined" margin="dense">
                    <InputLabel htmlFor='qano'>質問番号</InputLabel>
                    <OutlinedInput
                      value={form.qano}
                      id='qano'
                      name='qano'
                      label='質問番号'
                      onChange={handleChangeForm}
                      inputComponent={TextMaskInput as any}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={7}>
                  {customerList && customerList[0] && (
                    <FormControl className={classes.departmentWidth} variant="outlined" margin="dense" >
                      <Autocomplete
                        id="custmNo"
                        options={customerList!}
                        getOptionLabel={(option) => option.customerName}
                        onChange={(event, value, reason) => handleChangeCompanyCd(value)}
                        defaultValue={customerList!.filter(value => value.departmentCd === form.userId)[0]}
                        renderInput={(params) => (
                          <TextField {...params} label="顧客名 / 組織名" variant="outlined" size="small" />
                        )}
                        renderOption={(option, { inputValue }) => {
                          const matches = match((option.customerName), inputValue);
                          const parts = parse((option.customerName), matches);
                          return (
                            <div>
                              {parts.map((part, index) => (
                                <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                  {part.text}
                                </span>
                              ))}
                            </div>
                          );
                        }}
                      />
                    </FormControl>
                  )}
                </Grid>
              </Grid>
              <Grid item xs={8}>
                {contractList && contractList[0] && (
                  <FormControl className={classes.departmentWidth} variant="outlined" margin="dense" >
                    <Autocomplete
                      id="keiyakuClsCd"
                      options={contractList!}
                      getOptionLabel={(option) => option.keiyakuClsName}
                      defaultValue={contractList!.filter(value => value.keiyakuClsCd === form.keiyakuClsCd)[0]}
                      onChange={(event, value, reason) => handleChangeKeiyakuCd(value)}
                      renderInput={(params) => (
                        <TextField {...params} label="契約項目" variant="outlined" size="small" />
                      )}
                      renderOption={(option, { inputValue }) => {
                        const matches = match((option.keiyakuClsName), inputValue);
                        const parts = parse((option.keiyakuClsName), matches);
                        return (
                          <div>
                            {parts.map((part, index) => (
                              <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                {part.text}
                              </span>
                            ))}
                          </div>
                        );
                      }}
                    />
                  </FormControl>
                )}
              </Grid>
              <Grid item xs={12}>
                <FormControl variant="outlined" className={classes.mWidth} margin="dense">
                  <InputLabel id="qastatus" variant="outlined">ステータス</InputLabel>
                  <Select
                    labelId="qastatus"
                    id="qastatus"
                    label="ステータス"
                    name="qastatus"
                    multiple
                    value={form.qastatus}
                    onChange={handleChangeForm}
                    MenuProps={MenuProps}
                    renderValue={(selected) => (
                      <div className={classes.chips}>
                        {qastatusName && (
                          qastatusName.map((value, index) => (
                            <Chip
                              className={classes.chip}
                              color="primary"
                              variant="outlined"
                              size="small"
                              key={value}
                              label={value}
                              onMouseDown={(event) => {
                                event.stopPropagation();
                              }}
                              onDelete={(event) => chipDelete(index)} />
                          ))
                        )}
                      </div>
                    )
                    }
                  >
                    {qastatus && (
                      qastatus.map((value) => (
                        <MenuItem key={value.categoryCd} value={value.categoryCd}>
                          <Checkbox color="primary" checked={form.qastatus && (form.qastatus.indexOf(value.categoryCd) > -1)} />
                          <ListItemText primary={value.categoryName} />
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Grid container justify="flex-start">
                  <Grid item xs={12} sm={6}>
                    <InputLabel style={{ marginTop: '8px' }}>開始日</InputLabel>
                    <FormControl className={classes.mWidth} margin="dense" style={{ marginTop: '4px' }} error={datecheck} variant="outlined">
                      <wjInput.InputDate
                        initialized={_onInitialized}
                        valueChanged={_onValueChanged}
                        isRequired={false}
                        name='startdate'
                        value={startdate}
                      />
                      {datecheck ? <FormHelperText error>終了日よりも前の日付にしてください</FormHelperText>
                        : <FormHelperText>入力例: 1234/01/23</FormHelperText>}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputLabel style={{ marginTop: '8px' }}>終了日</InputLabel>
                    <FormControl className={classes.mWidth} margin="dense" style={{ marginTop: '4px' }} error={datecheck} variant="outlined">
                      <wjInput.InputDate
                        initialized={_onInitialized}
                        valueChanged={_onValueChanged}
                        isRequired={false}
                        name='enddate'
                        value={enddate}
                      />
                      {datecheck && <FormHelperText error>開始日よりも後の日付にしてください</FormHelperText>}
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={1} direction="row" justify="flex-start" alignItems="center">
                  <Grid item xs={5}>
                    {cisUserList && cisUserList[0] &&
                      <FormControl className={classes.lWidth} variant="outlined" margin="dense">
                        <Autocomplete
                          id="qaSeCd"
                          disabled={loginUser}
                          options={cisUserList}
                          defaultValue={cisUserList!.filter(value => value.userCd === form.qaSeCd)[0]}
                          getOptionLabel={(option) => `${option.userCd} ${option.userName}`}
                          onChange={(event, value, reason) => handleChangeSeCd(value)}
                          renderInput={(params) => (
                            <TextField {...params} label="担当SE" variant="outlined" size="small" />
                          )}
                          renderOption={(option, { inputValue }) => {
                            const matches = match(`${option.userCd} ${option.userName}`, inputValue);
                            const parts = parse(`${option.userCd} ${option.userName}`, matches);
                            return (
                              <div>
                                {parts.map((part, index) => (
                                  <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                    {part.text}
                                  </span>
                                ))}
                              </div>
                            );
                          }}
                        />
                      </FormControl>
                    }
                  </Grid>
                  <Grid item>
                    <FormControlLabel control={<Checkbox checked={loginUser} color="primary" onChange={handleSetLoginUserCd} name="loginUser" size="small" />} label="ログインユーザー" />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <FormControl className={classes.mWidth} margin="dense" variant="outlined">
                  <TextField id="keyword" name="keyword" label="キーワード" value={form.keyword}
                    size="small" onChange={handleChangeForm} variant="outlined" />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Grid container justify="center">
                  <div className={classes.wrapper}>
                    <Button variant="contained" color="primary" disabled={check} className={classes.button} onClick={onSubmit} >
                      検索
                    </Button>
                    {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                  </div>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </React.Fragment >
  )
}

export default QAListForm